<template>
	<section>
	<FormGroupBox title="Data">
		<b-form-row>
			<b-form-group class="col-6" label="Quote by*">
				<b-form-select
				size="sm"
				v-model="relatedModelType"
				:options="[
					{ value: 'supplier', text: 'Supplier' }
				]"
				required
				/>
			</b-form-group>
			<b-col>
				<b-form-group v-if="relatedModelType == 'supplier'" label="Supplier*">
					<b-form-select
						size="sm"
						v-model="form.supplier"
						:options="suppliersOpts"
					/>
				</b-form-group>
			</b-col>
		</b-form-row>
		<b-form-row>
			<b-form-group label="Origin*" class="col-12 col-lg-4">
				<vue-typeahead-bootstrap
				showAllResults
				size="sm"
				placeholder="Search"
				v-model="pickupSearch"
				:serializer="(place) => place.name"
				:data="pickupData"
				@hit="(selected) => (form.pickup = selected)"
				>
					<template #suggestion="{ data, htmlText }">
						<span v-html="htmlText"></span><br /><small>{{
						data.address
						}}</small>
					</template>
					<template #prepend>
						<b-input-group-text
						><md-icon :icon="pickupTypeIcon"
						/></b-input-group-text>
					</template>
					<template #append>
						<b-button variant="primary" @click="pickupEdit = false">
						<b-spinner v-if="pickupLoading" small />
						<span v-else>X</span>
						</b-button>
					</template>
				</vue-typeahead-bootstrap>
			</b-form-group>
			<b-form-group label="Destination*" class="col-12 col-lg-4">
				<vue-typeahead-bootstrap
				showAllResults
				size="sm"
				placeholder="Search"
				v-model="dropoffSearch"
				:serializer="(place) => place.name"
				:data="dropoffData"
				@hit="(selected) => (form.dropoff = selected)"
				>
				<template #suggestion="{ data, htmlText }">
					<span v-html="htmlText"></span><br /><small>{{
					data.address
					}}</small>
				</template>
				<template #prepend>
					<b-input-group-text
					><md-icon :icon="dropoffTypeIcon"
					/></b-input-group-text>
				</template>
				<template #append>
					<b-button variant="primary" @click="dropoffEdit = false">
					<b-spinner v-if="dropoffLoading" small />
					<span v-else>X</span>
					</b-button>
				</template>
				</vue-typeahead-bootstrap>
			</b-form-group>
			<b-col class="col-12 col-lg-3">
				<b-form-group :label="fieldNameDate">
					<b-form-datepicker
						aria-required="true"
						v-model="form.date"
						required
						size="sm"
						class="mb-1"
						locale="es"
						reset-button
						close-button
						:date-format-options="{
							year: 'numeric',
							month: 'short',
							day: '2-digit',
							weekday: 'short',
						}"
					/>
				</b-form-group>
			</b-col>
		</b-form-row>

		<br/>

		<b-form-checkbox v-model="form.advancedFields" class="mb-1">
			Show/Hide advanced fields
		</b-form-checkbox>
		<div v-show="form.advancedFields">
			<b-form-row>
				<b-form-group class="col-md-3" label="Sell by:">
					<multiselect
						v-model="form.sellSalesChannel"
						track-by="value"
						:options="channelOpts"
						label="text"
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-col md="3" v-if="relatedModelType=='supplier'">
						<b-form-group label="Booking Date">
							<b-form-datepicker
								aria-required="true"
								v-model="form.bookingDate"
								required
								size=""
								class="mb-1"
								locale="es"
								reset-button
								close-button
								:date-format-options="{
									year: 'numeric',
									month: 'short',
									day: '2-digit',
									weekday: 'short',
								}"
							/>
						</b-form-group>
					</b-col>
				<b-col md="1">
					<b-form-group
						label="Roundtrip?"
						class="text-center">
						<b-form-checkbox
							v-model="form.roundtrip"
							name="check-button"
							switch>
						</b-form-checkbox>
					</b-form-group>
				</b-col>
				<b-col md="3">
					<b-form-group label="Ida">
						<b-form-datepicker
							aria-required="true"
							v-model="form.serviceDate"
							required
							size=""
							class="mb-1"
							locale="es"
							reset-button
							close-button
							:date-format-options="{
								year: 'numeric',
								month: 'short',
								day: '2-digit',
								weekday: 'short',
							}"
						/>
						<vue-timepicker
						v-model="form.serviceTime"
						manual-input
						class="mb-1"
						></vue-timepicker>
					</b-form-group>
				</b-col>
				<b-col md="3">
					<b-form-group  label="Regreso" :disabled="!form.roundtrip">
						<b-form-datepicker
							aria-required="true"
							v-model="form.returnServiceDate"
							locale="es"
							reset-button
							close-button
							class="mb-1"
							:date-format-options="{
								year: 'numeric',
								month: 'short',
								day: '2-digit',
								weekday: 'short',
							}"
						/>
						<vue-timepicker
						v-model="form.returnServiceTime"
						manual-input
						class="mb-1"
						></vue-timepicker>
					</b-form-group>
				</b-col>
			</b-form-row>
		</div>
		<hr />
		<div class="text-center">
		<b-button @click="doQuote" variant="primary">Search prices</b-button>
		</div>
	</FormGroupBox>
	<FormGroupBox title="Prices" v-if="!loading">
		<div v-for="(price, index) in ratePlans" :key="index" >
			<h5 class="mb-0"><b>[{{price.ratePlan.supplier.id}}] {{price.ratePlan.supplier.name}}</b> {{ price.ratePlan.name }}</h5>
			<h6 class="text-muted mt-0"> {{price.pickupZone.name}}<md-icon icon="keyboard_double_arrow_right"/>{{price.dropoffZone.name}} </h6>
			<b-table striped hover :items="price.prices" :fields="fields" class="mb-4" stacked="lg">
				<template #cell(oneway)="row">
					<span>${{row.item.oneway}}</span>
				</template>
				<template #cell(roundtrip)="row">
					<span>${{row.item.roundtrip}}</span>
				</template>
				<template #cell(currency)="">
					<span class="text-uppercase">{{price.ratePlan.currency}}</span>
				</template>
				<template #cell(priceAfterPromotion)="row">
					<span v-if="!row.item.promo.found">--</span>
					<span v-else>
						<b v-if="lastSearched.roundtrip">[Roundtrip]</b>
						<b v-else>[Oneway]</b>
						${{row.item.promo.price}} {{price.ratePlan.currency}}
						<b-button variant="outline-success"  @click="showTracePromotion(row.item.promo.trace)" class="__shake" size="sm">
							<md-icon icon="local_offer" type="button" />
						</b-button>
					</span>
				</template>
			</b-table>
		</div>
		<!-- <b-row v-for="(price,index) in prices" :key="index">
				<b-col>{{price.serviceType.name}}</b-col>
				<b-col>
					<p>One Way: ${{price.oneway}} {{currency}}</p>
				</b-col>
				<b-col>
					<b-input-group size="sm">
						<b-input-group-prepend is-text>Roundtrip</b-input-group-prepend>
						<b-input-group-prepend is-text>$</b-input-group-prepend>
						<b-form-input disabled type="number" :value="price.roundtrip" required  />
						<b-input-group-append is-text>{{currency}}</b-input-group-append>
					</b-input-group>
				</b-col>
			</b-row> -->
	</FormGroupBox>
	<b-overlay :show="loading" no-wrap rounded></b-overlay>
	<b-modal ref="modalPromotionTrace" size="lg">
		<TracePromotion :tracePromotion="tracePromotion"></TracePromotion>
	</b-modal>
	</section>
</template>

<script>
import FormGroupBox from "../../helpers/FormGroupBox";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { debounce } from "debounce";
import moment from 'moment'
import Multiselect from 'vue-multiselect';
import TracePromotion from "../../helpers/TracePromo";
import vueTimepicker from "vue2-timepicker";
export default {
  components: { FormGroupBox, VueTypeaheadBootstrap,Multiselect,TracePromotion,vueTimepicker },
  data() {
	const today = moment().format("YYYY-MM-DD");
	let pickupPlaceModel  = { id: null, name: "", isAirport: false };
	let dropoffPlaceModel = { id: null, name: "", isAirport: false };

    return {
		relatedModelType: "supplier",
		validSuppliers: [],
		ratePlans: [],
		loading: false,
		pickupSearch: "",
		dropoffSearch: "",
		pickupLoading: false,
		dropoffLoading: false,
		pickupData: [],
		dropoffData: [],
		lastSearched:null,
		form:{
			advancedFields:false,
			date:today,
			supplier:null,
			roundtrip:false,
			serviceDate:today,
			serviceTime:"",
			returnServiceDate:null,
			returnServiceTime:"",
			bookingDate:today,
			pickup: {...pickupPlaceModel},
			dropoff: {...dropoffPlaceModel},
			sellSalesChannel:null
		},
		tracePromotion:{},
    };
  },
  methods: {
	showTracePromotion(trace) {
		this.tracePromotion = trace
		this.$refs["modalPromotionTrace"].show();
    },
    searchPlace(attrName, term) {
      if (term != "") {
        this[`${attrName}Loading`] = true;
        let query = {
          term,
          hasLocationData: true,
        };
        this.$root.api
          .post(`/places/search`, query)
          .then((res) => {
            this[`${attrName}Data`] = res.data;
            this[`${attrName}Loading`] = false;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
	validate(){
		try{
			if(this.$root.isEmpty(this.form.pickup.id)) throw "Pickup is required";
			if(this.$root.isEmpty(this.form.dropoff.id)) throw "Dropoff is required";
			if(this.$root.isEmpty(this.form.date)) throw "Date is required";
			if(this.form.advancedFields){
				if(this.relatedModelType=="supplier"){
					if(this.$root.isEmpty(this.form.bookingDate)) throw "Booking Date is required";
				}
				if(this.$root.isEmpty(this.form.serviceDate)) throw "Service Date is required";
				if( this.form.roundtrip && this.$root.isEmpty(this.form.returnServiceDate)) throw "return service Date is required";
			}
		}catch(err){
			this.$root.showAlert(err,{ variant: "warning" })
			return false;
		}
		return true;
	},
    doQuote() {
		if(!this.validate()) return;
		let query ={...this.form,...{modelType: this.relatedModelType}};
		this.lastSearched = {...query};
		this.loading = true;
		this.$root.api
		.post("/rates/quote", query)
		.then((res) => {
			this.ratePlans = res.data
		})
		.catch(this.$root.handleRequestError)
		.then(() => {
			this.loading = false;
		});
    },
  },
  computed: {
	fieldNameDate(){
		if(this.relatedModelType=="supplier")return "Assigned date"
		return "Booking date"
	},
    pickupTypeIcon() {
      let icon = "location_on";
      if (this.form.pickup.isAirport) icon = "flight";
      return icon;
    },
    suppliersOpts() {
		let opts = [{value:null,text:"All"}]
		let dbOptions = this.validSuppliers.map((sup) => ({ value: sup, text: sup.name }))
		let all  = [...opts,...dbOptions]
		return all;
    },
    dropoffTypeIcon() {
      let icon = "location_on";
      if (this.form.dropoff.isAirport) icon = "flight";
      return icon;
    },
	fields(){
		let columns= [
			{ key:"serviceType.name", label: "Service type" },
			{ key:"serviceType.maxPax", label: "Max pax" },
			{ key:"oneway", label: "Oneway" },
			{ key:"roundtrip", label: "roundtrip" },
			{ key:"currency", label: "currency" }
		]
		if(this.lastSearched.advancedFields){
			columns.push({ key:"priceAfterPromotion", label: "Price after Promotion" })
		}
		return columns;
	},
	channelOpts(){
		let aux= [...this.$root.auxVars.salesChannelsOpts];
		return aux;
	},
  },
  mounted() {
	this.$root.api
		.get("/rates/valid-suppliers")
		.then((res) => {
		this.validSuppliers = res.data;
		})
		.catch(this.$root.handleRequestError);
	this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['salesChannelsOpts']})

	if(process.env.NODE_ENV !== "production"){//test
		setTimeout(()=>{
			this.form.pickup = {
				id: 51543,
				name: "Cancun, Quintana Roo, Mexico",
				address: "Cancun - Chetumal Km 22, 77565 Canc\u00fan, Q.R., Mexico",
				ref: "scplace-51543",
				isAirport: true,
				type:"scplace"
			};
			this.form.dropoff = {
				id: 10488,
				name: "Adhara Hacienda Cancun",
				address: "Adhara Hacienda Cancun, Av Carlos Nader 6, 2A, 77500 Canc\u00fan, Q.R., Mexico",
				ref: "scplace-10488",
				isAirport: false,
				type:"scplace"
			}
			this.pickupSearch= this.form.pickup.name
			this.dropoffSearch= this.form.dropoff.name
		},0)
	}
  },
  watch: {
    pickupSearch: debounce(function (term) {
      this.searchPlace("pickup", term);
    }, 500),
    dropoffSearch: debounce(function (term) {
      this.searchPlace("dropoff", term);
    }, 500),
    // pickup(){
    // 	this.doQuote()
    // },
    // dropoff(){
    // 	this.doQuote()
    // },
    // supplier(){
    // 	this.doQuote()
    // }
  },
};
</script>

<style>
</style>
